import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  connect() {
    new window.autoNumeric(this.element, {
      digitGroupSeparator: ",",
      decimalCharacter: ".",
      decimalCharacterAlternative: ",",
      currencySymbol: "RD$\u202f",
      currencySymbolPlacement:
        window.autoNumeric.options.currencySymbolPlacement.prefix,
      roundingMethod: "D",
      decimalPlaces: 2,
      selectNumberOnly: true,
      unformatOnSubmit: true,
    });
  }
}
